export default "__VITE_ASSET__6oiBdNSa__"